module.exports = __webpack_public_path__ + "img/mtd.f915482a.png";